import '../plugins/FancyboxPlugin.js';
// Fancybox init
export default function initFancybox() {
	jQuery('[data-fancybox]:not([data-has-buttons="true"])').fancybox({
		hash: false,
		closeExisting: true,
	});

	jQuery(document).on('click', '.more-marketing', function (){
		initFancybox();
	})

	jQuery('[data-fancybox][data-has-buttons="true"]').fancybox({
		closeExisting: true,
		buttons: ['download_custom', 'share_custom', 'close'],
		hash: true,
		btnTpl: {
			share_custom: `
				<div class="wrap-share" data-fancybox-share-custom>
					<button class="fancybox-button fancybox-button--share" title="share" type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false" aria-controls="share fancybox">
						<svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.4375 9.25L18.1641 5.875L14.4375 2.53516V3.0625V4.1875C14.4375 4.50391 14.1562 4.75 13.875 4.75H12.75H12.1875H10.5C8.32031 4.75 6.5625 6.54297 6.5625 8.6875C6.5625 9.10938 6.59766 9.49609 6.73828 9.8125C7.23047 8.19531 8.74219 7 10.5352 7H12.1875H12.75H13.875C14.1562 7 14.4375 7.28125 14.4375 7.5625V8.6875V9.25ZM12.1875 8.6875H11.0625H10.5352C9.26953 8.6875 8.25 9.74219 8.25 11.0078C8.25 11.3242 8.28516 11.5703 8.39062 11.7812C8.46094 11.8867 8.49609 11.9922 8.56641 12.0977C8.60156 12.1328 8.63672 12.168 8.63672 12.2031C8.67188 12.2383 8.70703 12.2383 8.74219 12.2734C8.8125 12.3438 8.84766 12.3789 8.91797 12.4141C8.91797 12.4492 8.95312 12.4492 8.95312 12.4492C9.16406 12.625 9.375 12.8711 9.375 13.1523C9.375 13.4688 9.09375 13.75 8.74219 13.75H8.63672C8.56641 13.75 8.46094 13.75 8.39062 13.7148C8.32031 13.6797 8.21484 13.6445 8.10938 13.5742C8.00391 13.5039 7.86328 13.4336 7.6875 13.3633C7.51172 13.2227 7.30078 13.1172 7.08984 12.9414C6.07031 12.2031 4.875 10.832 4.875 8.6875C4.875 5.59375 7.37109 3.0625 10.5 3.0625H11.0625H12.1875H12.75V1.48047C12.75 0.8125 13.2773 0.25 13.9453 0.25C14.2617 0.25 14.543 0.390625 14.7539 0.566406L19.6406 4.96094C19.8867 5.20703 20.0625 5.52344 20.0625 5.875C20.0625 6.26172 19.8867 6.57812 19.6406 6.82422L14.7539 11.2188C14.543 11.4297 14.2617 11.5 13.9805 11.5H13.875C13.2422 11.5 12.75 11.0078 12.75 10.375V8.6875H12.1875ZM2.90625 1.375H5.15625C5.61328 1.375 6 1.76172 6 2.21875C6 2.71094 5.61328 3.0625 5.15625 3.0625H2.90625C2.41406 3.0625 2.0625 3.44922 2.0625 3.90625V15.7188C2.0625 16.2109 2.41406 16.5625 2.90625 16.5625H14.7188C15.1758 16.5625 15.5625 16.2109 15.5625 15.7188V13.4688C15.5625 13.0117 15.9141 12.625 16.4062 12.625C16.8633 12.625 17.25 13.0117 17.25 13.4688V15.7188C17.25 17.125 16.0898 18.25 14.7188 18.25H2.90625C1.5 18.25 0.375 17.125 0.375 15.7188V3.90625C0.375 2.53516 1.5 1.375 2.90625 1.375Z" /></svg>
					</button>
					<div class="drop-share dropdown-menu" id="share-drop-fancybox">
						<ul class="list-share">
							<li>
								<button data-clipboard-text="{{media}}" class=""><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-link"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path fill="none" d="M9 15l6 -6"></path><path fill="none" d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464"></path><path fill="none" d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463"></path></svg>
									<span>Copy link</span>
								</button>
							</li>
						</ul>
					</div>
				</div>
			`,
			download_custom: `<span data-fancybox-download-custom><a class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="{{media}}" target="_blank">
			<svg width="23" height="17" viewBox="0 0 23 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.6953 3.53906C11.9219 2.66016 10.7969 2.0625 9.53125 2.0625C7.17578 2.0625 5.3125 3.96094 5.3125 6.28125V6.31641C5.3125 7.01953 4.85547 7.65234 4.1875 7.89844C2.85156 8.35547 1.9375 9.62109 1.9375 11.0625C1.9375 12.9258 3.44922 14.4375 5.3125 14.4375H17.9688H18.0742C18.0742 14.4375 18.1094 14.4375 18.1445 14.4375C19.7617 14.3672 21.0625 12.9961 21.0625 11.3438C21.0625 10.0781 20.2891 8.98828 19.1992 8.53125C18.4961 8.21484 18.0742 7.47656 18.2148 6.70312C18.2148 6.5625 18.25 6.42188 18.25 6.28125C18.25 4.91016 17.0898 3.75 15.7188 3.75C15.332 3.75 14.9805 3.85547 14.6641 3.99609C13.9961 4.27734 13.1875 4.10156 12.6953 3.53906ZM18.25 16.125H17.9688H16.5625H5.3125C2.5 16.125 0.25 13.875 0.25 11.0625C0.25 8.88281 1.65625 6.98438 3.625 6.31641V6.28125C3.625 3.04688 6.26172 0.375 9.53125 0.375C11.2891 0.375 12.9062 1.18359 13.9961 2.44922C14.5234 2.20312 15.0859 2.0625 15.7188 2.0625C18.0391 2.0625 19.9375 3.96094 19.9375 6.28125C19.9375 6.52734 19.9023 6.73828 19.8672 6.98438C21.5547 7.72266 22.75 9.41016 22.75 11.3438C22.75 13.9102 20.7461 15.9844 18.25 16.125ZM8.08984 10.2539C7.73828 9.9375 7.73828 9.41016 8.08984 9.09375C8.40625 8.74219 8.93359 8.74219 9.28516 9.09375L10.6562 10.4648V5.71875C10.6562 5.26172 11.0078 4.875 11.5 4.875C11.957 4.875 12.3438 5.26172 12.3438 5.71875V10.4648L13.7148 9.09375C14.0312 8.74219 14.5586 8.74219 14.875 9.09375C15.2266 9.41016 15.2266 9.9375 14.875 10.2539L12.0625 13.0664C11.7461 13.418 11.2188 13.418 10.9023 13.0664L8.08984 10.2539Z" /></svg>
					</a></span>`,
		},
		share_custom: {
			url: function(instance, item) {
				return (
					(!instance.currentHash && !(item.type === "inline" || item.type === "html") ? item.origSrc || item.src : false) || window.location
				);
			},
		},
		afterShow: (instance, current) => {
			let tplShare, tplDownload = '';

			if (!current) {
				return;
			}

			if (current.type === "image") {
				let download = current.opts.$orig[0].dataset.download;
				tplShare = current.opts.btnTpl.share_custom
					.replace(/\{\{media\}\}/g, download);
				tplDownload = current.opts.btnTpl.download_custom
					.replace(/\{\{media\}\}/g, download);
			}

			instance.$refs.toolbar.find('[data-fancybox-share-custom]').html(tplShare);
			instance.$refs.toolbar.find('[data-fancybox-download-custom]').html(tplDownload);
		},
		beforeClose: (instance, current) => {
			jQuery(instance.$refs.toolbar).find('.drop-share').each(function() {
				let componentApi = window.bootstrap && window.bootstrap.Dropdown ? bootstrap.Dropdown.getOrCreateInstance(this) : null;
				componentApi && componentApi.hide();
			});
		},
		clickSlide: clickSlide,
		clickContent: function(current, event) {
			closeShareDrop(jQuery.fancybox.getInstance());

		    return current.type === "image" ? "zoom" : false;
		},
		mobile: {
			clickSlide: clickSlide,
			clickContent: function(current, event) {
				closeShareDrop(jQuery.fancybox.getInstance());

				return current.type === "image" ? "toggleControls" : false;
			},
		},

	});

	function clickSlide(current, event) {
		const $shareToolDrop = jQuery.fancybox.getInstance().$refs.toolbar.find('#share-drop-fancybox');
		const isOpen = $shareToolDrop.hasClass('show');

		closeShareDrop(jQuery.fancybox.getInstance());

		return isOpen ? false : "close";
	}

	function closeShareDrop(instance) {
		const $shareToolDrop = instance.$refs.toolbar.find('#share-drop-fancybox');

		if ($shareToolDrop.length) {
			let componentApi = window.bootstrap && window.bootstrap.Dropdown ? bootstrap.Dropdown.getOrCreateInstance($shareToolDrop[0]) : null;
			componentApi && componentApi.hide();
		}
	}

	function escapeHtml(string) {
		var entityMap = {
			"&": "&amp;",
			"<": "&lt;",
			">": "&gt;",
			'"': "&quot;",
			"'": "&#39;",
			"/": "&#x2F;",
			"`": "&#x60;",
			"=": "&#x3D;"
		};

		return String(string).replace(/[&<>"'`=\/]/g, function(s) {
			return entityMap[s];
		});
	}

	jQuery(document).on('click', '.main-modal-opener', function () {
		jQuery.fancybox.open({
			src: jQuery(this).attr('href'),
			touch: false,
			closeExisting: true,
			animationDuration: 500,
			helpers: {
				overlay: {
					css: {
						background: 'rgba(77, 77, 77, 0.2)'
					}
				}
			},
			baseClass: 'main-modal-transform',
			btnTpl: {
				smallBtn: `<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.1719 2.42188L9.54688 8L15.125 13.5781L15.9219 14.375L14.375 15.9688L13.5781 15.1719L8 9.59375L2.42188 15.1719L1.625 15.9688L0.03125 14.375L0.828125 13.5781L6.40625 8L0.828125 2.42188L0.03125 1.625L1.625 0.03125L2.42188 0.828125L8 6.45312L13.5781 0.875L14.375 0.078125L15.9688 1.625L15.1719 2.42188Z" /></svg>
				</button>`
			},
			beforeShow: () => {
				jQuery('.main-modal-transform').addClass('fancybox-anim-in');
			},
			beforeClose: (inst, current) => {
				// reset and pause video
				jQuery(current.$content).find('.video-wrap').removeClass('iframe-ready').find('iframe').attr('src', '');
				// anim classes
				jQuery('.main-modal-transform').removeClass('fancybox-anim-in').addClass('fancybox-anim-out');
			},
			afterShow: (inst, current) => {
				let $form = current.$content.find('form');
				if ($form) {
					$form.on('onAfterFormieSubmit', (e) => {
						e.preventDefault();

						let data = e.detail;
						if (data.success) {
							setTimeout(function () {
								window.open('/download-file?uid=' + $form.data('fileUid'), '_blank');
							}, 2000);
						}
					});
				}
			}
		});
	});
}